import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@environments/environment';
import { loadUserpilotSdk } from './load-userpilot-sdk';
import * as Sentry from '@sentry/angular';

if (environment.production) {
	enableProdMode();
}

Sentry.init({
	dsn: environment.sentryDsn,
	defaultIntegrations: false,
	integrations: [
		Sentry.dedupeIntegration(),
		Sentry.functionToStringIntegration(),
		Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: true }),
		Sentry.linkedErrorsIntegration(),
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false,
		}),
		Sentry.extraErrorDataIntegration(),
	],
	enabled: environment.environmentName === 'production',
	denyUrls: [/userpilot\.io/i, /\/sdk\/version\/[^/]+\/app\.js/i, /oppwa\.com/i],
	ignoreErrors: [
		'ResizeObserver loop completed with undelivered notifications.',
		'ResizeObserver loop limit exceeded',
		'NS_ERROR_FAILURE',
	],
	tracesSampleRate: 0.1,
	tracePropagationTargets: [/^https:\/\/secure\.infodocs\.co\.za/],
	sendDefaultPii: true,
	enableLogs: true,
	environment: environment.environmentName,
	// Session Replay
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

loadUserpilotSdk(environment.userpilotToken)
	.then(() => bootstrapApplication(AppComponent, appConfig))
	.catch(err => console.error(err));
